"use client";

import React, { useState } from "react";
import { Typography } from "@aph/ui-lib-humanx";
import { COMPONENT_TYPES, HOME_PAGE_TITLE, ONBOARDED_HOME_PAGE_TITLE, TYPE_ARTICLE } from "@/helpers/constants";
import routes from "@/helpers/router";
import Breadcrumbs from "@/components/Breadcrumbs";
import FilterResourceNavBar from "@/components/PageArticleListing/Components/FilterResourceNavBar";
import { PageResourceCategory } from "@/components/PageArticleListing/helpers";
import NavBar from "@/components/Header/NavBar";
import { serverReturnType } from "@/components/PageAllResources/interfaces";
// import FilterComponent from "@/components/FilterComponent";
import ComponentMapping from "@/components/PageAllResources/componentMapping";
import { getNavBarInfoForCategoryRouting } from "@/helpers";
import { categoryFilterValues } from "@/components/PageAllResources/helpers";
import styles from "./PageAllResources.module.scss";

interface AllResourceListingProps {
  pageInfo: serverReturnType;
  categorySlug?: string;
}

const AllResourceListing: React.FC<AllResourceListingProps> = ({ pageInfo, categorySlug }) => {
  const resourcesInfo = pageInfo?.resourcesInfo;
  const userAgent = pageInfo?.ua;
  const userOnBoarded = pageInfo?.userOnBoarded;
  const navBarList = pageInfo?.navBarList;
  // const filters = pageInfo?.filterData;

  const navBarInfo = getNavBarInfoForCategoryRouting(navBarList?.data);
  const pathname: string = `${routes.resourcesListing(undefined, categorySlug || PageResourceCategory.resources)}`;
  const resourceContent = resourcesInfo?.data?.attributes?.ResourceContent;

  const categoryList = resourceContent?.find((data: any) => data.ComponentType === COMPONENT_TYPES.CategoryList);
  const categories = categoryList?.CategoryList?.map((data) => {
    return { name: data?.CategoryName, category: data?.Slug, slug: routes.resourcesListing(undefined, data?.Slug) };
  });

  // const [isFilterOpen, setIsFilterOpen] = useState(false);

  const breadCrumbsArray = [
    {
      label: pageInfo?.userOnBoarded ? ONBOARDED_HOME_PAGE_TITLE : HOME_PAGE_TITLE,
      url: routes.home,
    },
    {
      label: "All Resources",
      url: routes.resourcesListing(),
    },
  ];

  return (
    <>
      <NavBar
        navBarData={{ navBarList: navBarInfo }}
        userOnBoarded={userOnBoarded}
        userAgent={userAgent}
        pathname={pathname}
      />
      <div className="container">
        <div className={`breadcrumb`}>
          <Breadcrumbs options={breadCrumbsArray} />
        </div>
        <FilterResourceNavBar navBarData={categories} pageCategory={categorySlug || PageResourceCategory.resources} />
      </div>
      <div className={userAgent?.isMobile ? styles.allResourcesContainerMobile : styles.allResourcesContainer}>
        <div className={styles.resources}>
          <div>
            <div className={`${styles.titleWrapper} ${styles.borderClass}`}>
              <Typography component="h1" className={styles.textMargin}>
                {`${categorySlug ? `${categoryFilterValues[categorySlug]} ` : ""}Resources`}
              </Typography>
              {/*<Typography className={styles.filterText} onClick={() => setIsFilterOpen(true)}>*/}
              {/*  <span className={"icon-icon-filter"} />*/}
              {/*</Typography>*/}
            </div>
          </div>
        </div>
        {resourceContent.map((content: any, index: number) => (
          <ComponentMapping data={content} key={index} extras={{ userAgent, userOnBoarded, categorySlug }} />
        ))}
      </div>
      {/*<FilterComponent*/}
      {/*  categorySlug={categorySlug}*/}
      {/*  filters={filters}*/}
      {/*  setIsFilterOpen={setIsFilterOpen}*/}
      {/*  isFilterOpen={isFilterOpen}*/}
      {/*  userAgent={userAgent}*/}
      {/*/>*/}
    </>
  );
};

export default AllResourceListing;
